// extracted by mini-css-extract-plugin
export default {"post":"Post_post__RToYF","capa":"Post_capa__nZpkq","title":"Post_title__UfHCr"};